// study-setting.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';

@Pipe({
    standalone: true,
    name: 'categoricalDisplayValue'
})
export class CategoricalDisplayValuePipe implements PipeTransform {
    transform(value: any, variable: ObservationVariable, matchBy: 'name' | 'id' | 'both' = 'id', isCategoricalDescriptionView: boolean | 'description_only' = false): string {
        if (!value || !variable.termId) {
            return '';
        }
        if (variable.possibleValues?.length) {
            let valueReference: any;
            if (matchBy === 'both') {
                valueReference = variable.possibleValues.find(p =>
                    p.name.toString() === value.toString() || p.id.toString() === value.toString()
                );
            } else {
                valueReference = variable.possibleValues.find(p =>
                    p[matchBy].toString() === value.toString()
                );
            }
            if (isCategoricalDescriptionView === 'description_only') {
                return `${valueReference.description}`;
            }
            if (isCategoricalDescriptionView && valueReference?.description) {
                return `${valueReference.name} - ${valueReference.description}`;
            }
            return valueReference?.name || variable?.value || value;
        }
        return value;
    }
}
